module.exports = __webpack_public_path__ + "static/media/silhouette.2a23e6a0.svg";